import React from 'react';
import { ProductReviews } from '../components/ProductReviews';

const Reviews = () => (
  <div className="pt-28 pb-24 min-h-screen">
    <div className="max-w-6xl mx-auto px-5">
      <div className="text-center mb-12">
        <p className="font-jost text-xs tracking-[0.4em] text-[#ff4da6] uppercase mb-3">In Their Words</p>
        <h1 className="font-cinzel text-4xl md:text-6xl text-gold-gradient">Customer Love</h1>
        <div className="gold-divider mt-4" />
        <p className="font-cormorant text-xl text-[#f5ecd9]/70 max-w-2xl mx-auto mt-5">Real routines, real results — from glowing skin to hydrated, defined hair.</p>
      </div>
      <ProductReviews showHistorical={true} />
    </div>
  </div>
);

export default Reviews;
